import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatBot from "./components/ChatBot";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import SafetyCenterPage from "./pages/SafetyCenterPage";
import ContactPage from "./pages/ContactPage";
import IndustriesPage from "./pages/IndustriesPage";
import CareersPage from "./pages/CareersPage";
import ComparePage from "./pages/ComparePage";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-skytec-bg">
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/service-areas" element={<ServiceAreasPage />} />
              <Route path="/locations" element={<ServiceAreasPage />} />
              <Route path="/safety" element={<SafetyCenterPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/industries" element={<IndustriesPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/compare" element={<ComparePage />} />
            </Routes>
          </main>
          <Footer />
          <ChatBot isOpen={isChatOpen} setIsOpen={setIsChatOpen} />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
